var Theme = Theme || {};

// is in viewport
function inViewport(elem, callback, options = {}) {
  return new IntersectionObserver((entries) => {
    entries.forEach((entry) => callback(entry));
  }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function (arg) {
  document.body.classList.toggle(arg);
};
// Get Element Height
function getElementHeight(targetElement, appendTo, cssVar) {
  let element = document.querySelector(targetElement);

  if (element) {
    let elementHeight = element.offsetHeight;
    document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
  }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => {
  const roundedVh = Math.round(window.innerHeight * 0.01);
  document.body.style.setProperty("--vh", `${roundedVh}px`);
};
window.addEventListener("resize", getSetVh);

// Browser check
function getNavigator() {
  const isiOS =
    navigator.userAgent.match(/(iPhone|iPad|iPod)/) &&
    navigator.userAgent.match(/AppleWebKit/) &&
    !navigator.userAgent.match(/CriOS/);
  const isSafari =
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
    Object.prototype.toString.call(window.HTMLElement).indexOf("Constructor") > 0 ||
    (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1);
  const isChrome =
    (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)) ||
    navigator.userAgent.indexOf("Chrome") != -1;
  const isFirefox =
    typeof InstallTrigger !== "undefined" || navigator.userAgent.indexOf("Firefox") != -1;
  const isEdge = !!window.StyleMedia || navigator.userAgent.indexOf("Edge") != -1;

  if (isiOS) document.documentElement.classList.add("ios");
  if (isSafari) document.documentElement.classList.add("safari");
  if (isChrome) document.documentElement.classList.add("chrome");
  if (isFirefox) document.documentElement.classList.add("firefox");
  if (isEdge) document.documentElement.classList.add("edge");
}

// Toggle
let toggleClass = function (qSelectors, bodyClass) {
  document
    .querySelectorAll(qSelectors)
    .forEach((e) => e.addEventListener("click", () => toggleBodyClass(bodyClass)));
};
// Menu
let toggleMenu = function () {
  toggleClass(".fire-menu, .shrink-menu", "open-menu");
};

function initializeDetailsControls() {
  // Handle dropdown menu
  const detailsElementsLv1 = document.querySelectorAll("details.lv1");
  const detailsElementsClosex = [...document.querySelectorAll("details.closex")];

  function closeOtherDetails(element) {
    const detailsOpened = document.querySelectorAll("details[open].lv1");
    for (const item of detailsOpened) {
      if (element !== item) {
        item.removeAttribute("open");
      }
    }
  }

  function closeAllDetailsExcept(target) {
    // Check if we're clicking on a lv1 summary (to toggle the main dropdown)
    const clickedLv1Summary = target.closest('details.lv1 > summary');
    const clickedLv1 = target.closest('details.lv1');
    
    // If clicking on lv1 summary to toggle, wait for browser to finish then restore state if needed
    if (clickedLv1Summary && clickedLv1) {
      // Use setTimeout to run AFTER the browser's native toggle completes
      setTimeout(() => {
        // If dropdown was closed (no open attribute after browser toggle)
        if (!clickedLv1.hasAttribute('open')) {
          // Restore initial state for nested first elements
          detailsElementsClosex.forEach((f) => {
            if (f.classList.contains("first")) {
              f.classList.add("initial");
              f.setAttribute("open", "open");
            }
          });
        }
        a11yDetails();
      }, 0);
      return; // Exit early, let browser handle the toggle
    }
    
    detailsElementsClosex.forEach((f) => {
      // Close any details that don't contain the click target (so clicking Accessories closes Surfboards)
      if (!f.contains(target)) {
        f.removeAttribute("open");
      }
      // Remove "initial" so we don't keep the first submenu open when user picks another
      if (f.classList.contains("initial")) {
        f.classList.remove("initial");
      }
    });
    
    a11yDetails();
  }

  function closeAllDetails() {
    detailsElementsClosex.forEach((f) => f.removeAttribute("open"));
    detailsElementsClosex.forEach((f) => {
      if (f.classList.contains("first")) {
        f.classList.add("initial");
        f.setAttribute("open", "open");
      }
    });
    a11yDetails();
  }

  // Dropdown menu
  detailsElementsLv1.forEach((item) => {
    item.addEventListener("click", function () {
      closeOtherDetails(this);
    });
  });

  // lv2 summaries (Surfboards, Accessories): prevent toggle closing the menu; open clicked, close others
  document.querySelectorAll('details.lv2.closex > summary').forEach((summary) => {
    summary.addEventListener("click", function (e) {
      const details = this.closest('details.lv2');
      if (!details) return;
      e.preventDefault();
      // Close other lv2, open this one
      detailsElementsClosex.forEach((f) => {
        if (f.classList.contains('lv2') && f !== details) {
          f.removeAttribute("open");
        }
      });
      details.setAttribute("open", "open");
      if (details.classList.contains("initial")) {
        details.classList.remove("initial");
      }
      a11yDetails();
    });
  });

  // Close details when clicked outside
  document.addEventListener("click", function (e) {
    if (!detailsElementsClosex.some((f) => f.contains(e.target))) {
      closeAllDetails();
    } else {
      closeAllDetailsExcept(e.target);
    }
  });

  // Close details with esc key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      closeAllDetails();
    }
  });

  // Initial accessibility settings
  a11yDetails();
}

function a11yDetails() {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

    if (summary.nextElementSibling && summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    // Only add click handler once (prevent duplicates)
    if (!summary.hasAttribute('data-a11y-bound')) {
      summary.setAttribute('data-a11y-bound', 'true');
      summary.addEventListener("click", (event) => {
        // Wait for browser to toggle the open attribute, then sync aria-expanded
        setTimeout(() => {
          const details = event.currentTarget.closest("details");
          const isOpen = details ? details.hasAttribute("open") : false;
          event.currentTarget.setAttribute("aria-expanded", isOpen);
        }, 0);
      });
    }
  });
}

// update button price on variant change
function updatePrice(obj, idd) {
  var uid = obj.options[obj.selectedIndex].getAttribute("data-price");
  var pb = document.querySelector(".uprice" + idd);
  pb.innerHTML = uid;
}

function selectOptions(obj, idd) {
  updatePrice(obj, idd);
}

// Bullet marquee
if (!customElements.get("bullet-marquee"))
  customElements.define(
    "bullet-marquee",
    class bulletMarquee extends HTMLElement {
      constructor() {
        super();
        if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this);
      }

      duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute("bullet-speed") || 5);
        const contentWidth = entries[0].contentRect.width;

        // Calculate the slowFactor based on content width
        let slowFactor =
          contentWidth <= 375
            ? 1
            : contentWidth >= 1280
            ? 3
            : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (
          (scrollingSpeed * slowFactor * entries[0].target.querySelector("span").clientWidth) /
          contentWidth
        ).toFixed(3);

        this.style.setProperty("--bullet-speed", `${scrollingDuration}s`);
      }
    }
  );

/*** init app */
function app() {
  getSetVh(); // get Viewport Height
  getNavigator(); // get the browser + OS
  toggleMenu(); // toggle Menu
  initializeDetailsControls(); // call details
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => {
  app();
});
